import { COMMON_EMAIL_DOMAINS } from "../constants/searchConfig";
import { extractLinkedInVanity } from "@/app/components/utils/linkedinUtils";

export const getSmartSuggestion = (input, type) => {
  if (type === "email") {
    return getEmailSuggestion(input);
  }

  if (type === "linkedin") {
    return getLinkedInSuggestion(input);
  }

  return null;
};

const getEmailSuggestion = (input) => {
  // Email domain auto-completion
  if (input.includes("@") && !input.includes(".")) {
    const [user, domain] = input.split("@");
    if (domain && domain.length > 0) {
      const matches = COMMON_EMAIL_DOMAINS.filter((d) =>
        d.startsWith(domain.toLowerCase())
      );
      if (matches.length > 0) {
        return `${user}@${matches[0]}`;
      }
    }
  }
  return null;
};

const getLinkedInSuggestion = (input) => {
  const cleanInput = input.toLowerCase().trim();

  // Handle various LinkedIn input formats and normalize them

  // Case 1: Just "linkedin" or "linkedin johndoe" - suggest full URL
  if (cleanInput.includes("linkedin") && !cleanInput.includes("/")) {
    const username = input.replace(/linkedin\s*/i, "").trim();
    if (username) {
      return `linkedin.com/in/${username}`;
    }
    return "linkedin.com/in/";
  }

  // Case 2: "linkedin.com/" without "/in/" - add the /in/ part
  if (cleanInput.includes("linkedin.com/") && !cleanInput.includes("/in/")) {
    // Extract potential username after linkedin.com/
    const match = cleanInput.match(/linkedin\.com\/(.+)/);
    if (match && match[1]) {
      const username = match[1].replace(/\/$/, ""); // remove trailing slash
      return input.replace(/linkedin\.com\/.*/i, `linkedin.com/in/${username}`);
    }
    return input.replace(/linkedin\.com\//i, "linkedin.com/in/");
  }

  // Case 3: Incomplete linkedin.com/in/ URL - help complete it
  if (cleanInput.includes("linkedin.com/in/") && cleanInput.endsWith("/in/")) {
    return input; // Let user continue typing username
  }

  // Case 4: URL with query params or trailing slash - clean it up
  if (cleanInput.includes("linkedin.com/in/")) {
    const vanity = extractLinkedInVanity(input);
    if (vanity) {
      return `linkedin.com/in/${vanity}`;
    }
  }

  // Case 5: Just a username without linkedin prefix
  if (
    !cleanInput.includes("linkedin") &&
    !cleanInput.includes("@") &&
    cleanInput.length > 2
  ) {
    if (/^[a-zA-Z0-9-]+$/.test(cleanInput)) {
      return `linkedin.com/in/${cleanInput}`;
    }
  }

  return null;
};

export const shouldShowSuggestion = (input, suggestion, type) => {
  if (!suggestion || suggestion === input) return false;

  if (type === "linkedin") {
    const vanity = extractLinkedInVanity(input);
    if (vanity && vanity.length > 2) {
      return false;
    }
  }

  return true;
};
